import serverData from './server-data'

export const backURL = '/businessmanage/credentials/apiAccess/'
export const homeURL = '/businessprofile/settings'
export const dashboardURL = '/'

export const headers = {
  'x-csrf-token': serverData._csrf,
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

export const baseURL = '/identitylegacyweb'
export const managePermissions = '/managePermissions'
export const accountAuthenticateLogin = '/accountAuthenticateLogin'
export const accessPermissionLogin = '/accessPermissionLogin'
export const consentURL = '/businessprofile/partner/consents/'
export const saveUserDetails = '/saveUserDetails'
export const POST = 'POST'
export const GET = 'GET'

export const ppImg =
  'https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg'

export const mobileScreenSize = 750